// TODO: Ensure that this is updated to come from the database
export const technologyList = [
  {
    label: "Sinatra",
    value: "sinatra",
    icon: "",
    id: 69
  },
  {
    label: 'Javascript',
    value: 'javascript',
    icon: '',
    id: 68
  },
  {
    label: "Shopify",
    value: "shopify",
    icon: "",
    id: 67
  },
  {
    label: "Liquid",
    value: "liquid",
    icon: "",
    id: 66
  },
  {
    label: "ElectronJS",
    value: "electronjs",
    icon: "",
    id: 65
  },
  {
    label: "iOS",
    value: "iOS",
    icon: "",
    id: 64
  },
  {
    label: "Android",
    value: "android",
    icon: "",
    id: 63
  },
  {
    label: "Pyramid",
    value: "pyramid",
    icon: "",
    id: 62
  },
  {
    label: "Flask",
    value: "flask",
    icon: "",
    id: 61
  },
  {
    label: "Django",
    value: "django",
    icon: "",
    id: 60
  },
  {
    label: "Rspec",
    value: "rspec",
    icon: "",
    id: 59
  },
  {
    label: "Cucumber",
    value: "cucumber",
    icon: "",
    id: 58
  },
  {
    label: "Jasmine",
    value: "jasmine",
    icon: "",
    id: 57
  },
  {
  label: "Twig",
  value: "twig",
  icon: "",
  id: 56
  },
  {
  label: "Jest",
  value: "jest",
  icon: "",
  id: 55
  },
  {
  label: "Mocha",
  value: "mocha",
  icon: "",
  id: 54
  },
  {
  label: "Chai",
  value: "chai",
  icon: "",
  id: 53
  },
  {
  label: "Groovy",
  value: "groovy",
  icon: "",
  id: 52
  },
  {
  label: "Maven",
  value: "maven",
  icon: "",
  id: 51
  },
  {
  label: "Spring",
  value: "spring",
  icon: "",
  id: 50
  },
  {
  label: "Express",
  value: "express",
  icon: "",
  id: 49
  },
  {
  label: "Gulp",
  value: "gulp",
  icon: "",
  id: 48
  },
  {
  label: "Grunt",
  value: "grunt",
  icon: "",
  id: 47
  },
  {
  label: "Browserify",
  value: "browserify",
  icon: "",
  id: 46
  },
  {
  label: "KnockoutJS",
  value: "knockout",
  icon: "",
  id: 45
  },
  {
  label: "Aurelia",
  value: "aurelia",
  icon: "",
  id: 44
  },
  {
  label: "Sencha",
  value: "sencha",
  icon: "",
  id: 43
  },
  {
  label: "BackboneJS",
  value: "backbone",
  icon: "",
  id: 42
  },
  {
  label: "Meteor",
  value: "meteor",
  icon: "",
  id: 41
  },
  {
  label: "Visual Basic",
  value: "visualbasic",
  icon: "",
  id: 40
  },
  {
  label: "UnrealScript",
  value: "unrealscript",
  icon: "",
  id: 39
  },
  {
  label: "Swift",
  value: "swift",
  icon: "",
  id: 38
  },
  {
    label: "Powershell",
    value: "powershell",
    icon: "",
    id: 37
    },
    {
    label: "Lisp",
    value: "lisp",
    icon: "",
    id: 36
    },
    {
    label: "Coffeescript",
    value: "coffeescript",
    icon: "",
    id: 35
    },
    {
    label: "Elm",
    value: "elm",
    icon: "",
    id: 34
    },
    {
    label: "Elixir",
    value: "elixir",
    icon: "",
    id: 33
    },
    {
    label: "AEM",
    value: "aem",
    icon: "",
    id: 32
    },
    {
    label: "Perl",
    value: "perl",
    icon: "",
    id: 31
    },
    {
    label: "Go",
    value: "go",
    icon: "",
    id: 30
    },
    {
    label: "R",
    value: "r",
    icon: "",
    id: 29
    },
    {
    label: "Objective C",
    value: "objective_c",
    icon: "",
    id: 28
    },
    {
    label: "Shell",
    value: "shell",
    icon: "",
    id: 27
    },
    {
    label: "HTML",
    value: "html",
    icon: "",
    id: 26
    },
    {
    label: "LESS",
    value: "less",
    icon: "",
    id: 25
    },
    {
    label: "SASS",
    value: "sass",
    icon: "",
    id: 24
    },
    {
    label: "SCSS",
    value: "scss",
    icon: "",
    id: 23
    },
    {
    label: "CSS",
    value: "css",
    icon: "",
    id: 22
    },
    {
    label: "jQuery",
    value: "jquery",
    icon: "",
    id: 21
    },
    {
    label: "Bootstrap",
    value: "bootstrap",
    icon: "",
    id: 20
    },
    {
    label: "PHP",
    value: "php",
    icon: "",
    id: 19
    },
    {
    label: "VueJS",
    value: "vuejs",
    icon: "",
    id: 18
    },
    {
    label: "EmberJS",
    value: "emberjs",
    icon: "",
    id: 17
    },
    {
    label: ".NET",
    value: "dot_net",
    icon: "",
    id: 16
    },
    {
    label: "C",
    value: "c",
    icon: "",
    id: 15
    },
    {
    label: "C#",
    value: "c_sharp",
    icon: "",
    id: 14
    },
    {
    label: "C++",
    value: "c_plus_plus",
    icon: "",
    id: 13
    },
    {
    label: "Angular",
    value: "angular",
    icon: "",
    id: 12
    },
    {
    label: "ReactJS",
    value: "reactjs",
    icon: "",
    id: 11
    },
    {
    label: "Kotlin",
    value: "kotlin",
    icon: "",
    id: 10
    },
    {
    label: "Haskell",
    value: "haskell",
    icon: "",
    id: 9
    },
    {
    label: "Python",
    value: "python",
    icon: "",
    id: 8
    },
    {
      label: "AWS",
      value: "aws",
      icon: "",
      id: 7
      },
      {
      label: "Typescript",
      value: "typescript",
      icon: "",
      id: 6
      },
      {
      label: "Ruby on Rails",
      value: "ruby_on_rails",
      icon: "",
      id: 5
      },
      {
      label: "Ruby",
      value: "ruby",
      icon: "",
      id: 4
      },
      {
      label: "Java",
      value: "java",
      icon: "",
      id: 3
      },
      {
      label: "VanillaJS",
      value: "vanillajs",
      icon: "",
      id: 2
      },
      {
      label: "NodeJS",
      value: "nodejs",
      icon: "",
      id: 1
      }
]